// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pv95T","content":"styles_content__GobWH","row":"styles_row__rUNvt","footer":"styles_footer__3XQvy","phraseLength":"styles_phraseLength__10dEs"};